import React from "react";
import _ from "lodash";
import {
  convertHoursToDays,
  displayPriceFormat,
  formatCategoryName,
  getPendingOrderProductPriceWithoutPromo,
  getPendingOrderProductPriceWithPromo
} from "../../utils";
import styles from "./OrderItem.styles";
import { DISHOP_GREEN, UNIT } from "../../constants/configuration";
import { deleteItem, findOptionParent } from "./OrderItem.services";
import { useAppSelector } from "../../redux/hook";
import OrderItemOption from "./components/OrderItemOption";
import OrderItemInstruction from "./components/OrderItemInstruction";
import Spinner from "../Spinner";
import SkeletonRow from "../Skeleton/SkeletonRow.view";
import { Typography, Box } from "@mui/material";
import { Counter } from "@dishopsaas/design-system";

export default function OrderItem({
  deleteOption,
  cartItem,
  cartItemKey,
  isLoading = false,

  isPastOrder = false,

}) {
  const { nb, unit = null, name, price, preparationTime } = cartItem;
  const { secondaryColor } = useAppSelector(
    (state) => state.configurationReducer
  );
  const {
    userConnected,
    user: { customerId },
    isUserAnonymous,
  } = useAppSelector((state) => state.userReducer);

  const displayPriceAsync = (price) =>
    isLoading ? <Spinner /> : displayPriceFormat(price);
  const renderOptions = () => {
    const { items } = cartItem;
    if (items) {
      return _.map(items, (item) => {
        if (item) {
          const { options, categoryKey } = item;
          const optionLabels = _.map(options, 'name');
          const isChild = _.some(
            items,
            (childItem) =>
              childItem?.categoryKey !== categoryKey &&
              categoryKey.includes(childItem?.categoryKey)
          );
          const prefix = isChild ? '- ' : '* ';
          const fontSize = isChild ? UNIT * 0.85 : UNIT * 0.9;
          const className = isChild ? 'ml-4' : 'ml-2';
          let { categoryName } = item;
          if (options && isChild) {
            _.forEach(options, (option) => {
              const optionParent = findOptionParent(option, items);
              if (optionParent) {
                categoryName = formatCategoryName({
                  shopCategory: { name: item.categoryName },
                  parentItemLabel: optionParent.label,
                  parentItemRecursiveKey: optionParent.itemRecursiveKey,
                  isMultiple: optionParent.categoryMultiple,
                });
              }
            });
          }
          const itemRenderString = `${prefix}${categoryName}: ${optionLabels.join(
            ','
          )}`;
          return (
            <OrderItemOption
              className={className}
              fontSize={fontSize}
              itemRenderString={itemRenderString}
              categoryId={item.categoryId}
            />
          );
        }
      });
    }
  };


  const hasPromo =
    getPendingOrderProductPriceWithoutPromo(price) !==
    getPendingOrderProductPriceWithPromo(price);
  return (
    <Box>
      <div style={{ padding: 16 }}>
        <SkeletonRow
          label={
            <div>
              {deleteOption && (
                <div className={`mr-2`}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      deleteItem({
                        userConnected,
                        isUserAnonymous,
                        cartItem,
                        cartItemKey,
                        customerId,
                      });
                    }}
                  >
                    <i
                      className="far fa-trash-alt"
                      style={{ color: secondaryColor }}
                    />
                  </a>
                </div>
              )}
              <>
                <Box sx={styles.receiptProductItemTitleDefaultStyle}>
                  <Counter value={nb} />
                  <Typography variant="subtitle1" sx={styles.itemName}>
                    {unit ? `${unit} de ${name}` : name}
                  </Typography>
                </Box>
              </>
            </div>
          }
          amount={
            <div style={{ display: 'flex', columnGap: '10px' }}>
              {hasPromo && (
                <div style={{ color: DISHOP_GREEN }}>

                  <Typography variant="subtitle1">  {displayPriceAsync(
                    getPendingOrderProductPriceWithPromo(price)
                  )}</Typography>

                </div>
              )}
              <div
                style={{ textDecoration: hasPromo ? 'line-through' : 'unset' }}
              >

                <Typography variant="subtitle1">
                  {displayPriceAsync(
                    getPendingOrderProductPriceWithoutPromo(price)
                  )}
                </Typography>

              </div>
            </div>
          }
          isLoading={isLoading}
          style={{ ...styles.productItem }}
        />
        <Box>
          {cartItem.items && (
            <SkeletonRow
              label={
                <Box sx={{ pl: isPastOrder ? "46px" : "39px", pr: 4 }}>
                  {renderOptions()}
                </Box>
              }
              isLoading={isLoading}
            />
          )}
          {cartItem.instruction && (
            <SkeletonRow
              label={
                <Box sx={{ pl: isPastOrder ? "46px" : "39px", pr: 4, ml: !isPastOrder && 2 }}>
                  <OrderItemInstruction instruction={cartItem.instruction} />
                </Box>
              }
              isLoading={isLoading}
            />
          )}
          {preparationTime > 0 && deleteOption && (
            <p
              className="ml-2 text-warning mb-0"
              style={{ fontSize: UNIT * 0.9 }}
            >
              {`~ ${convertHoursToDays(preparationTime) > 0
                ? `${convertHoursToDays(preparationTime)} jour(s)`
                : `${preparationTime} heure(s)`
                } de préparation`}
            </p>
          )}
        </Box>
      </div>
    </Box>
  );
}